import React, { useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import { useSelector } from "react-redux";

import { getConsultingId, getMonths } from "../../utils/utils";
import { Checkbox, Menu, MenuItem, Typography } from "@material-ui/core";
import { tabs, unoTheme } from "../../../assets/styles/unoTheme";

import { StatusDpinDairAPI } from "../../../API/status_dpin_dair";
import { UserAPI } from "../../../API/user";
import { checkUserIsRole, roles } from "../../utils/user";
import UnoButton from "../../utils/UnoButton";
import MyAutoComplete from "../../utils/MyAutoComplete";
import MySelect2 from "../../utils/MySelect2";

import FilterListIcon from '@material-ui/icons/FilterList';
import GetAppIcon from '@material-ui/icons/GetApp';
import GridOnIcon from '@material-ui/icons/GridOn';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PeopleIcon from '@material-ui/icons/People';

import { MyTab, MyTabs } from "../../utils/MyTabs";

import MarketingTab from "./statusClients/tabs/MarketingTab";
import SuitabilityTab from "./marketing/tabs/SuitabilityTab";
import { RECIPIENT_TYPES, ALL_RECIPIENT_TYPE_KEYS } from "./marketing/marketingContacts";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    tabs: tabs,

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
}));

export default function MarketingScreen(props) {

    const { selectedYearClosure } = props;

    const classes = useStyles();

    const currentUser = useSelector(state => state.currentUser)

    const [tabValue, setTabValue] = useState(0);

    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);
    };

    //Advisors
    const [activeAdvisors, setActiveAdvisors] = useState(null);
    async function doGetActiveAdvisorsAndAdmins() {
        const response = await UserAPI.getActiveAdvisorsAndAdminsByConsulting(getConsultingId(currentUser));
        if (response.success) {
            setActiveAdvisors(response.body.rows);
        }
    }

    const [selectedAdvisor, setSelectedAdvisor] = useState(currentUser.user);
    const handleAdvisorSelectedClient = (event, newValue) => {
        setSelectedAdvisor(newValue);
    }

    //Statuses DAIR: a lista completa resolve o status gravado de cada cliente; só os
    //ativos são oferecidos no filtro.
    const [statusesDair, setStatusesDair] = useState(null);
    const activeStatusesDair = useMemo(() => (statusesDair || []).filter(el => el.active !== false), [statusesDair]);

    async function loadStatusesDair() {
        const response = await StatusDpinDairAPI.getStatusesDair();
        if (response.success) {
            setStatusesDair(response.body.rows);
        }
    }

    const months = useMemo(() => getMonths(), []);

    //DAIR/DPIN: filtros locais à aba (não refazem requisição, apenas re-derivam a lista)
    const [marketingMonthSelected, setMarketingMonthSelected] = useState(new Date().getMonth());
    const [selectedMarketingStatusIds, setSelectedMarketingStatusIds] = useState([]); //vazio = todos
    const [selectedRecipientTypes, setSelectedRecipientTypes] = useState(ALL_RECIPIENT_TYPE_KEYS);
    const [anchorElFilterMarketingStatus, setAnchorElFilterMarketingStatus] = useState(null);
    const [anchorElFilterRecipientTypes, setAnchorElFilterRecipientTypes] = useState(null);
    const [anchorElMarketingActions, setAnchorElMarketingActions] = useState(null);
    const marketingTabRef = useRef(null);
    const suitabilityTabRef = useRef(null);

    //O menu de download é um só; cada aba expõe doExcel/doCopyEmails pelo ref.
    const activeTabRef = tabValue === 0 ? marketingTabRef : suitabilityTabRef;

    //Multi-seleção: lista vazia significa "todos", mesma convenção do
    //BackofficeReportGenerator. Evita ter que marcar 14 status para ver tudo.
    function toggleMarketingStatus(statusId) {
        setSelectedMarketingStatusIds((current) => current.includes(statusId)
            ? current.filter((id) => id !== statusId)
            : [...current, statusId]);
    }

    function toggleRecipientType(typeKey) {
        setSelectedRecipientTypes((current) => {
            //Sem nenhum tipo marcado a lista fica vazia e a aba perde sentido:
            //desmarcar o último não é permitido.
            if (current.includes(typeKey)) {
                return current.length === 1 ? current : current.filter((key) => key !== typeKey);
            }

            return [...current, typeKey];
        });
    }

    function renderMenuFilterMarketingStatus(items) {

        const menuList = [];

        menuList.push(<MenuItem
            key={'menu-marketing-status-all'}
            onClick={() => setSelectedMarketingStatusIds([])}>
            <Checkbox color='primary' size='small' style={{ padding: '0px 6px 0px 0px' }}
                checked={selectedMarketingStatusIds.length === 0} />
            <Typography style={{ fontSize: '10px' }}>{'TODOS'}</Typography>
        </MenuItem >);

        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-marketing-status-' + item.id}
                onClick={() => toggleMarketingStatus(item.id)}>
                <Checkbox color='primary' size='small' style={{ padding: '0px 6px 0px 0px' }}
                    checked={selectedMarketingStatusIds.includes(item.id)} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    function renderMenuFilterRecipientTypes() {

        return RECIPIENT_TYPES.map(type => (
            <MenuItem
                key={'menu-recipient-type-' + type.key}
                onClick={() => toggleRecipientType(type.key)}>
                <Checkbox color='primary' size='small' style={{ padding: '0px 6px 0px 0px' }}
                    checked={selectedRecipientTypes.includes(type.key)} />
                <Typography style={{ fontSize: '10px' }}>{type.label.toUpperCase()}</Typography>
            </MenuItem >
        ));
    }

    useEffect(() => {
        loadStatusesDair();
        doGetActiveAdvisorsAndAdmins();
    }, []);

    const advisorFilter = activeAdvisors ?
        <MyAutoComplete
            id={'advisor-filter-marketing'}
            disabled={!checkUserIsRole(currentUser, [roles.superadmin, roles.admin])}
            options={activeAdvisors}
            autoComplete
            customWidth={'250px'}
            value={
                selectedAdvisor ? selectedAdvisor : null
            }
            onChange={(event, newValue) => {
                handleAdvisorSelectedClient(event, newValue)
            }}
            label={'Consultor'}
            placeholder={"Selecione o consultor"}
            getOptionLabel={(option) => option.name.toUpperCase()}
            getOptionSelected={(option, value) => option.id === value.id}
            renderOption={(option) => (
                <React.Fragment key={'autocomplete-' + option.id}>
                    <span>{option.name.toUpperCase()}</span>
                </React.Fragment>
            )}
        /> : <Typography variant='body1' style={{ whiteSpace: 'nowrap', marginRight: '16px' }}>{selectedAdvisor && selectedAdvisor.name.toUpperCase()}</Typography>;

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: 'auto' }}>
                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="DAIR/DPIN" value={0} />
                        <MyTab label="Suitability" value={1} />

                    </MyTabs>
                </div>

                {
                    tabValue === 0 &&
                    <div className={classes.rightHeader}>

                        <MySelect2
                            style={{ marginTop: '0px', marginRight: '16px' }}
                            id={'months-in-filter-marketing'}
                            value={marketingMonthSelected}
                            onChange={(e) => setMarketingMonthSelected(e.target.value)}
                            options={months.map((row, index) => (
                                <option key={'month-filter-marketing-' + index} value={index}>
                                    {row}
                                </option>
                            ))}
                        />

                        <UnoButton
                            style={{ marginRight: '16px' }}
                            startIcon={<FilterListIcon />}
                            onClick={(e) => setAnchorElFilterMarketingStatus(e.currentTarget)}
                            type='primaryClean'>
                            {selectedMarketingStatusIds.length
                                ? 'STATUS (' + selectedMarketingStatusIds.length + ')'
                                : 'TODOS OS STATUS'}
                        </UnoButton>

                        <UnoButton
                            style={{ marginRight: '16px' }}
                            startIcon={<PeopleIcon />}
                            onClick={(e) => setAnchorElFilterRecipientTypes(e.currentTarget)}
                            type='primaryClean'>
                            {selectedRecipientTypes.length === ALL_RECIPIENT_TYPE_KEYS.length
                                ? 'TODOS OS CONTATOS'
                                : 'CONTATOS (' + selectedRecipientTypes.length + ')'}
                        </UnoButton>

                        {advisorFilter}

                        <UnoButton
                            isIconButton
                            style={{ marginLeft: '8px' }}
                            myIcon={<GetAppIcon />}
                            onClick={(e) => setAnchorElMarketingActions(e.currentTarget)}
                            type='primary' />

                    </div>
                }

                {
                    tabValue === 1 &&
                    <div className={classes.rightHeader}>

                        <UnoButton
                            style={{ marginRight: '16px' }}
                            startIcon={<PeopleIcon />}
                            onClick={(e) => setAnchorElFilterRecipientTypes(e.currentTarget)}
                            type='primaryClean'>
                            {selectedRecipientTypes.length === ALL_RECIPIENT_TYPE_KEYS.length
                                ? 'TODOS OS CONTATOS'
                                : 'CONTATOS (' + selectedRecipientTypes.length + ')'}
                        </UnoButton>

                        {advisorFilter}

                        <UnoButton
                            isIconButton
                            style={{ marginLeft: '8px' }}
                            myIcon={<GetAppIcon />}
                            onClick={(e) => setAnchorElMarketingActions(e.currentTarget)}
                            type='primary' />

                    </div>
                }

            </div>

            {tabValue === 0 && <MarketingTab
                ref={marketingTabRef}
                selectedYearClosure={selectedYearClosure}
                selectedAdvisor={selectedAdvisor}
                statusesDair={statusesDair}
                monthSelected={marketingMonthSelected}
                selectedStatusIds={selectedMarketingStatusIds}
                selectedRecipientTypes={selectedRecipientTypes}
            />}
            {tabValue === 1 && <SuitabilityTab
                ref={suitabilityTabRef}
                selectedAdvisor={selectedAdvisor}
                selectedRecipientTypes={selectedRecipientTypes}
            />}

            {activeStatusesDair.length ?
                <Menu
                    id="filter-marketing-status-menu"
                    anchorEl={anchorElFilterMarketingStatus}
                    keepMounted
                    open={Boolean(anchorElFilterMarketingStatus)}
                    onClose={() => setAnchorElFilterMarketingStatus(null)}>
                    {renderMenuFilterMarketingStatus(activeStatusesDair)}
                </Menu> : null
            }

            <Menu
                id="filter-recipient-types-menu"
                anchorEl={anchorElFilterRecipientTypes}
                keepMounted
                open={Boolean(anchorElFilterRecipientTypes)}
                onClose={() => setAnchorElFilterRecipientTypes(null)}>
                {renderMenuFilterRecipientTypes()}
            </Menu>

            <Menu
                id="marketing-actions-menu"
                anchorEl={anchorElMarketingActions}
                keepMounted
                open={Boolean(anchorElMarketingActions)}
                onClose={() => setAnchorElMarketingActions(null)}>
                <MenuItem onClick={() => {
                    setAnchorElMarketingActions(null);
                    activeTabRef.current && activeTabRef.current.doExcel();
                }}>
                    <GridOnIcon fontSize={'small'} style={{ color: unoTheme.greenMoney, marginRight: '8px' }} />
                    <Typography style={{ fontSize: '12px' }}>{'Planilha Excel'}</Typography>
                </MenuItem>
                <MenuItem onClick={() => {
                    setAnchorElMarketingActions(null);
                    activeTabRef.current && activeTabRef.current.doCopyEmails(';');
                }}>
                    <FileCopyIcon fontSize={'small'} style={{ marginRight: '8px' }} />
                    <Typography style={{ fontSize: '12px' }}>{'Copiar e-mails (;) - Outlook'}</Typography>
                </MenuItem>
                <MenuItem onClick={() => {
                    setAnchorElMarketingActions(null);
                    activeTabRef.current && activeTabRef.current.doCopyEmails(',');
                }}>
                    <FileCopyIcon fontSize={'small'} style={{ marginRight: '8px' }} />
                    <Typography style={{ fontSize: '12px' }}>{'Copiar e-mails (,) - Gmail'}</Typography>
                </MenuItem>
            </Menu>

        </div>
    );
}
